import styled from "styled-components";
export const FirstFilesWrapper = styled.div``;
